import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationOntologyForAutomaticValuableConceptCreateRequest, ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'

class ValuableConceptConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationOntologyForAutomaticValuableConceptResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationOntologyForAutomaticValuableConceptResponse>>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticValuableConcept`, filterModel, { params })
        return response.data
    }

    async getValuableConceptById(laboratoryId: number, ontologyForAutomaticValuableConceptId : number): Promise<ConfigurationOntologyForAutomaticValuableConceptResponse> {
        const response = await axios.get<ConfigurationOntologyForAutomaticValuableConceptResponse>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticValuableConcept/${ontologyForAutomaticValuableConceptId}`)
        return response.data
    }

    async createValuableConcept(laboratoryId: number, request: ConfigurationOntologyForAutomaticValuableConceptCreateRequest): Promise<ConfigurationOntologyForAutomaticValuableConceptResponse> {
        const response = await axios.post<ConfigurationOntologyForAutomaticValuableConceptResponse>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticValuableConcept`, request)
        return response.data
    }

    async deleteValuableConcept(laboratoryId: number, ontologyForAutomaticValuableConceptIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticValuableConcept/batch`, { data: ontologyForAutomaticValuableConceptIds })
        return response.data
    }
}

export const valuableConceptConfigurationServices = new ValuableConceptConfigurationServices()
